import { render, staticRenderFns } from "./CustomerTrashList.vue?vue&type=template&id=e3d8d0ac&scoped=true&"
import script from "./CustomerTrashList.vue?vue&type=script&lang=js&"
export * from "./CustomerTrashList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTrashList.vue?vue&type=style&index=0&id=e3d8d0ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d8d0ac",
  null
  
)

export default component.exports